(function () {
  const tiltEl = document.getElementById("bg-tilt");
  const stampsLayer = document.querySelector(".bg-stamps");
  if (!tiltEl || !stampsLayer) return;

  const root = document.documentElement;

  const readPx = (name, fallback) => {
    const v = getComputedStyle(root).getPropertyValue(name).trim();
    const n = parseFloat(v.replace("px",""));
    return Number.isFinite(n) ? n : fallback;
  };

  const readDeg = (name, fallbackDeg) => {
    const v = getComputedStyle(root).getPropertyValue(name).trim();
    const n = parseFloat(v.replace("deg",""));
    return Number.isFinite(n) ? n : fallbackDeg;
  };

  // ✅ حركة الخلفية (سرّعها هنا)
  const BASE_VX = 0.85; // كانت بطيئة — زودناها
  const BASE_VY = 0.55;

  let mx = window.innerWidth / 2;
  let my = window.innerHeight / 2;

  // offsets اللي بتحرك الجريد
  let ox = 0, oy = 0;

  // stamps: كل واحدة مربوطة بـ cell (cx,cy) وتتحرك مع الجريد
  const stamps = []; // {el,cx,cy,t0,dur}
  let lastCellKey = "";

  const snapCell = (n, grid) => Math.floor(n / grid);

  function screenToTiltCoords(clientX, clientY){
    const rect = tiltEl.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;

    const dx = clientX - cx;
    const dy = clientY - cy;

    // inverse rotate
    const deg = readDeg("--tilt", -8);
    const rad = (-deg) * Math.PI / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);

    const x = dx * cos - dy * sin;
    const y = dx * sin + dy * cos;

    return {
      x: x + rect.width / 2,
      y: y + rect.height / 2
    };
  }

  function addStamp(cx, cy, grid){
    const el = document.createElement("div");
    el.className = "bg-stamp";
    stampsLayer.appendChild(el);

    stamps.push({
      el,
      cx,
      cy,
      t0: performance.now(),
      dur: 900 // مدة بقاء “الغمقة” (ms) — ظبطها لو تحب
    });

    // performance cap
    if (stamps.length > 90) {
      const old = stamps.shift();
      old?.el?.remove();
    }
  }

  function onMove(e){
    mx = e.clientX;
    my = e.clientY;

    const grid = readPx("--grid", 76);
    const p = screenToTiltCoords(mx, my);

    // ✅ أهم نقطة: snap على grid بعد ما نخصم offset بتاع حركة الجريد
    const cx = snapCell(p.x - ox, grid);
    const cy = snapCell(p.y - oy, grid);

    const key = cx + "," + cy;

    // نضيف stamp فقط لما ندخل مربع جديد
    if (key !== lastCellKey) {
      lastCellKey = key;
      addStamp(cx, cy, grid);
    }
  }

  window.addEventListener("mousemove", onMove, { passive: true });

  function tick(){
    const grid = readPx("--grid", 76);

    // ✅ حركة الجريد أسرع + “حيّة” مع الماوس
    const cx = (mx / window.innerWidth) - 0.5;
    const cy = (my / window.innerHeight) - 0.5;

    ox += BASE_VX + (cx * 0.35);
    oy += BASE_VY + (cy * 0.25);

    // حط offsets في CSS
    root.style.setProperty("--ox", ox + "px");
    root.style.setProperty("--oy", oy + "px");

    // ✅ خلّي الـstamps تتحرك مع الجريد وتفضل ثابتة على نفس المربع
    const now = performance.now();
    for (let i = stamps.length - 1; i >= 0; i--) {
      const s = stamps[i];
      const t = (now - s.t0) / s.dur;

      if (t >= 1) {
        s.el.remove();
        stamps.splice(i, 1);
        continue;
      }

      // موقع stamp مرتبط بالـcell + offsets
      const x = (s.cx * grid) + ox;
      const y = (s.cy * grid) + oy;

      s.el.style.left = x + "px";
      s.el.style.top  = y + "px";

      // fade-out ناعم
      s.el.style.opacity = String(1 - t);
    }

    requestAnimationFrame(tick);
  }

  tick();
})();